import React from "react";
import { Modal } from './Modal'
import { SideModal } from "./SideModal";
import { useNavigate } from "react-router-dom";

function GlobalCreditModal(props) {
    const navigate = useNavigate();
    const { heading, message, onCancel, onConfirm, loading = false } = props;

    const isMobileScreen = window.innerWidth < 768;
    return (
        <div className={`absolute md:fixed top-0 min-h-screen bg-black bg-opacity-30 backdrop-blur-sm flex justify-center px-5  items-center w-full ${isMobileScreen ? "z-0" : "z-30"}`}>
            <Modal width={"w-1/4"} handleClose={() => { }}>
                <div className="text-center w-full">

                    <svg className='mx-auto' width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_7617_1695)">
                            <mask id="mask0_7617_1695" maskUnits="userSpaceOnUse" x="0" y="0" width="56" height="56">
                                <path d="M56 0H0V56H56V0Z" fill="white" />
                            </mask>
                            <g mask="url(#mask0_7617_1695)">
                                <path d="M52 28C52 14.7452 41.2548 4 28 4C14.7452 4 4 14.7452 4 28C4 41.2548 14.7452 52 28 52C41.2548 52 52 41.2548 52 28Z" fill="#FFD7D5" />
                                <path d="M23 19V22.4C23 22.9601 23 23.2401 23.109 23.454C23.2049 23.6422 23.3578 23.7951 23.546 23.891C23.7599 24 24.0399 24 24.6 24H31.4C31.9601 24 32.2401 24 32.454 23.891C32.6422 23.7951 32.7951 23.6422 32.891 23.454C33 23.2401 33 22.9601 33 22.4V20M33 37V30.6C33 30.0399 33 29.7599 32.891 29.546C32.7951 29.3578 32.6422 29.2049 32.454 29.109C32.2401 29 31.9601 29 31.4 29H24.6C24.0399 29 23.7599 29 23.546 29.109C23.3578 29.2049 23.2049 29.3578 23.109 29.546C23 29.7599 23 30.0399 23 30.6V37M37 25.3255V32.2C37 33.8802 37 34.7202 36.673 35.362C36.3854 35.9265 35.9265 36.3854 35.362 36.673C34.7202 37 33.8802 37 32.2 37H23.8C22.1198 37 21.2798 37 20.638 36.673C20.0735 36.3854 19.6146 35.9265 19.327 35.362C19 34.7202 19 33.8802 19 32.2V23.8C19 22.1198 19 21.2798 19.327 20.638C19.6146 20.0735 20.0735 19.6146 20.638 19.327C21.2798 19 22.1198 19 23.8 19H30.6745C31.1637 19 31.4083 19 31.6385 19.0553C31.8425 19.1043 32.0376 19.1851 32.2166 19.2947C32.4184 19.4184 32.5914 19.5914 32.9373 19.9373L36.0627 23.0627C36.4086 23.4086 36.5816 23.5816 36.7053 23.7834C36.8149 23.9624 36.8957 24.1575 36.9447 24.3615C37 24.5917 37 24.8363 37 25.3255Z" stroke="#FF0000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M52 28C52 14.7452 41.2548 4 28 4C14.7452 4 4 14.7452 4 28C4 41.2548 14.7452 52 28 52C41.2548 52 52 41.2548 52 28Z" stroke="#FEF2F2" stroke-width="8" />
                            </g>
                        </g>
                        <defs>
                            <clipPath id="clip0_7617_1695">
                                <rect width="56" height="56" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>

                    <p className='text-xl text-slate-700 font-semibold text-Inter mt-3 capitalize'>{"No Active Subscription"}</p>
                    <p className='text-md mt-2 text-secondarySupport text-Inter'>
                        Your current subscription plan has expired or been cancelled. Due to this, you would not be able to access some of the features. To continue enjoying uninterrupted service and access all premium features, please subscribe to a plan now.
                    </p>

                    <div className='flex item-center justify-evenly gap-x-5 mt-6'>
                        {/* <button onClick={() => { onCancel() }} className='px-4 py-2 w-full text-sm text-Inter font-[500] rounded-lg border-[1px] border-gray-400'>
                    Cancel
                </button> */}
                        <button onClick={() => { navigate('/settings') }} className='px-4 py-2 w-full text-sm text-Inter bg-primary text-white font-[500] rounded-lg border-[1px] border-primary'>
                            Subscribe
                        </button>
                    </div>
                </div>
            </Modal>
        </div>
    );
}

export default GlobalCreditModal;
